export default function SelectInput({
  label,
  name,
  value,
  onChange,
  options = [],
  placeholder = "Select…",
  required,
}) {
  return (
    <label className="field">
      <span className="field-label">{label}</span>
      <select
        className="field-select"
        name={name}
        value={value ?? ""}
        onChange={onChange}
        required={required}
      >
        <option value="">{placeholder}</option>
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </label>
  );
}
